import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "chat-bubble-bot self-end flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.3em",
    viewBox: "0 0 640 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M544 0H96V176H64V160H0v64H64V208H96V416H224v96l144-96H544V208h32v16h64V160H576v16H544V0zM160 96H480V288H160V96zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z",
      style: {"fill":"var(--icon-text-color)"}
    })
  ])
], -1)
const _hoisted_2 = { class: "chat-bubble-bot py-2 px-3 rounded-md text-md leading-6" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatBubbleBot',
  props: {
  isText: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chat-bubble flex w-full space-x-3 max-w-[90%]", {
      "chat-bubble-text": __props.isText
    }])
  }, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})